import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ReturnsTab } from "@/components/returns/tabs/ReturnsTab";
import { UnpaidCreditsTab } from "@/components/returns/tabs/UnpaidCreditsTab";
import { DeliveriesTab } from "@/components/returns/tabs/DeliveriesTab";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
export default function Returns() {
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState("returns");
  const tabs = [{
    id: "returns",
    label: "Retours"
  }, {
    id: "unpaid",
    label: "Crédits impayés"
  }, {
    id: "deliveries",
    label: "Livraisons"
  }];
  const renderTabContent = (value: string) => {
    switch (value) {
      case "returns":
        return <ReturnsTab />;
      case "unpaid":
        return <UnpaidCreditsTab />;
      case "deliveries":
        return <DeliveriesTab />;
      default:
        return null;
    }
  };
  return <DashboardLayout userType="owner">
      <div className="container py-0">
        <h1 className="text-3xl font-bold mb-6">Retours et crédits</h1>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          {isMobile ? <div className="mb-4">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="outline" className="w-full flex justify-between items-center">
                    <span>{tabs.find(tab => tab.id === activeTab)?.label || "Sélectionner"}</span>
                    <Menu className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-[200px]">
                  {tabs.map(tab => <DropdownMenuItem key={tab.id} onClick={() => setActiveTab(tab.id)}>
                      {tab.label}
                    </DropdownMenuItem>)}
                </DropdownMenuContent>
              </DropdownMenu>
            </div> : <TabsList className="grid w-full grid-cols-3">
              {tabs.map(tab => <TabsTrigger key={tab.id} value={tab.id}>
                  {tab.label}
                </TabsTrigger>)}
            </TabsList>}

          {tabs.map(tab => <TabsContent key={tab.id} value={tab.id}>
              {renderTabContent(tab.id)}
            </TabsContent>)}
        </Tabs>
      </div>
    </DashboardLayout>;
}